jQuery(document).ready(function ($) {
	//back to top
	var btn = $('.back_to_top');  
	$(window).scroll(function() {     
		if ($(window).scrollTop() > 500) {
			 btn.fadeIn();
		 } else {
			 btn.fadeOut();
		 }
	 });
	 btn.on('click', function(e) {
		 e.preventDefault();
		 $('html, body').animate({scrollTop:0}, '300');
	 });
	
	//change type of input
	$('.entry_field').find('button').on('click', function(){
		var input = $(this).siblings('input');
		if(input.attr('readonly')){
			input.removeAttr('readonly');
			input.trigger('focus');
		}else{
			input.attr('readonly');
		}
	});

	//modal window
	var modalBtn = $('a[data-modal]');
	var closeBtn = $('.close_modal');
	var modalWindow = $('.modal_wrapper');
	var body = $('body');

	modalBtn.on('click', function (e) {
		e.preventDefault();
		var modalId = $(this).data('modal');
		$('#' + modalId + '').parent().addClass('active');
		body.addClass('fixed_body');
	});

	function closeModal(params) {
		modalWindow.removeClass('active');
		body.removeClass('fixed_body');    
	}

	modalWindow.on('click', function (e) {
		closeModal();
	}).children().on('click', function (e) {
		e.stopPropagation();
	});

	closeBtn.on('click', function (e) {
		e.preventDefault();
		closeModal();
	});


	//checkbox id
	if ($('.checkbox_wrapper').length > 0) {
		$('.checkbox_wrapper').each(function (index) {
			$(this).find('label').attr('for', 'check_' + index + '');
			$(this).find('input').attr('id', 'check_' + index + '');
		});
	}

	if ($('.checkbox_item').length > 0) {
		$('.checkbox_item').each(function (index) {
			$(this).find('label').attr('for', 'check_' + index + '');
			$(this).find('input').attr('id', 'check_' + index + '');
		});
	}


	//switcher
	if($('.switcher').length > 0){
		$('.switcher').on('click', function(){
			$(this).toggleClass('active');
		});
	}



	/*select
	$('.select_btn').on('click', function () {
		$(this).toggleClass('active');
		$(this).siblings('.select_dropdown').toggleClass('active');          
	 });
	
	$('.select_dropdown li a').on('click', function(e){
		e.preventDefault();
		var value = $(this).text();
		$(this).parents('.select_wrapper').find('.select_btn').removeClass('active').find('span').text(value);
		$(this).parents('.select_dropdown').removeClass('active');
	});

	$('.more_info').on('click', function(e){
		$(this).siblings('.more_info_block').toggleClass('active');        
	})*/

	function closeBlock(parent,block,add,type) {
		$(document).mouseup(function (e){ 
			var div = parent;
			if (!div.is(e.target) && div.has(e.target).length === 0) {
				if (type == 2) {
					div.find(block).slideUp();
					div.find(add).removeClass('active');          
				} else {
					div.find(block).removeClass('active');
					div.find(add).removeClass('active');          
				}
			}
		});        
	};
	closeBlock($('.more_info_wrapper'),$('.more_info_block'), null,1);
	closeBlock($('.select_wrapper'), $('.select_dropdown'), $('.select_btn'), 1);
	
	

	//tabs
	if($('.tab_switcher').length > 0){
		$('.tab_switcher:first-of-type').addClass('active');
		$('.tabs_wrapper').each(function () {
			$(this).find('.tab_item').first().show();
		})

		$('.tab_switcher').on('click', function(){
			$(this).siblings('.tab_switcher').removeClass('active');
			$(this).addClass('active');
			$(this).parents('.tabs_wrapper').find('.tab_item').hide();
			$(this).parents('.tabs_wrapper').find('.tab_item').eq($(this).index()).fadeIn();
		})
	}

	//accordion
	/*
	$('.report_sections').on('click', '.accordion_head', function(){
		$(this).parent().siblings('.accordion_wrapper').removeClass('active');
		$(this).parent().siblings('.accordion_wrapper').find('.accordion_body').slideUp();
		$(this).parent().toggleClass('active');
		$(this).siblings('.accordion_body').slideToggle();
	});

	$('.accordion_head').on('click', function(){
		$(this).parent().siblings('.accordion_wrapper').removeClass('active');
		$(this).parent().siblings('.accordion_wrapper').find('.accordion_body').slideUp();
		$(this).parent().toggleClass('active');
		$(this).siblings('.accordion_body').slideToggle();
	});
	*/

	//alerts
	$('.close_alert').on('click', function(){
		$(this).parent().fadeOut();
		$(this).parent().addClass('disabled');
		var alertsWrap = document.querySelectorAll('.alert_demontration');
		var alertsArr = document.querySelectorAll('.alert');
		for (var i = 0; i < alertsArr.length; i++){
			if (alertsArr[i].classList.contains('disabled')){
				hideAlert(i, alertsWrap);
			}
		}
	})

	function hideAlert(e, array){
		for (var j = 0; j < array.length; j++){
			var height = array[e].offsetHeight;
			var newHeight = height - height;
			array[e].style.height = newHeight + 'px';
		}
	}


	//remove
	$('.remove_btn').on('click', function () {
		$(this).parents('tr').remove();
	});


	//range
	if($('.custom_range').length > 0){
		$('.custom_range').each(function(){
			var width = $(this).find('.range_value').attr('data-width');
			$(this).find('.range_value').css('width', '' + width + '%');
			$(this).find('.range_value').text(width);
		})
	}

	//sortable row for tables
	//$('table').tablesorter({ sortList: [[0, 0], [1, 0]] });
	
	//search for tables
	/*$('input[type=search]').on('keyup', function() {
		var value = $(this).val().toLowerCase();
		var table = $(this).parents('.white_box').find('tbody');
		var tableRow = table.find('tr');
		tableRow.filter(function() {
			 $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
		});
	});*/

	//show filter reviews
	if ($('.show_filter').length > 0) {
		$('.show_filter').on('click', function () {
			$(this).toggleClass('active');
			$(this).parents('.review_card').find('.filter_reviews_wrapper').slideToggle();
		});
	};
	closeBlock($('.filter_sticky'), $('.filter_reviews_wrapper'), $('.show_filter'), 2);
	
	if ($('.show_sticky').length > 0) {
		$('.show_sticky').on('click', function () {
			$(this).toggleClass('active');
			$(this).parents('.sticky_block_key').find('.sticky_block_key_wrapper').slideToggle();
		});
	};
	if ($(window).width() < 1201) {
		closeBlock($('.sticky_block_key'), $('.sticky_block_key_wrapper'), $('.show_sticky'), 2);    
	}

	//move menu
	if ($('.header_navigation').length > 0) {
		moveNav();
		moveOther();
		$(window).on('resize', function () {
			moveNav();
			moveOther();
		});
	}

	function moveNav() {
		if ($(window).width() < 1201) {
			$('.nav').appendTo('.mobile_wrapper');
		} else {
			$('.nav').appendTo('.header_navigation .container');
		}
	}

	function moveOther() {
		if ($(window).width() < 769) {
			$('.search_wrapper').appendTo('.mobile_wrapper');
			$('.websites_list_wrapper').appendTo('.mobile_wrapper');
			$('.profile_settings_wrapper').appendTo('.mobile_wrapper');
		} else {
			$('.search_wrapper').appendTo('.header_navigation .container');
			$('.websites_list_wrapper').appendTo('.header_navigation .container');
			$('.profile_settings_wrapper').appendTo('.header_navigation .container');
		}
	}

	if ($('.burger').length > 0) {
		if ($(window).width() < 1201) {
			$('.burger').on('click', function() {
				$('.mobile_wrapper').slideToggle();
			});
		}
	}

	if ($(window).width() > 768) {
		$(document).mouseup(function (e){ 
			var div = $('.mobile_wrapper');
			if (!div.is(e.target) && div.has(e.target).length === 0) {
				div.removeClass('active');
			}
		});
	}

	if ($('.clean_input').length > 0) {
		$('.clean_input').on('click', function () {
			$(this).parent().find('label').css("visibility", "visible");
		})
	}

});
